import React from 'react';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';

export type FilterPopoverContentOwnProps = {
    resetDisabled?: boolean;
    children: React.ReactNode;
};

export type FilterPopoverContentProps = FilterPopoverContentOwnProps;

const FilterPopoverContent: React.FC<FilterPopoverContentProps> = (props) => {
    return (
        <Stack vertical space={contentStackSpacing}>
            {props.children}
        </Stack>
    );
};

export default React.memo(FilterPopoverContent);
